package org.example.project.engineSnap

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.project.dashboard.DashboardTheme
import org.example.project.dashboard.ContentOffset
import org.example.project.dashboard.PopupEngineCard
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.letterSpacing
import org.jetbrains.compose.web.css.opacity
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun SnapOwnKeyDialog(
    snapKey: String,
    title: String = "Dein SnapKey",
    onClose: () -> Unit,
    onCopy: () -> Unit
) {
    val scope = rememberCoroutineScope()
    var copyActive by remember(snapKey) { mutableStateOf(false) }

    PopupEngineCard(
        windowKey = "snap-own-key-dialog",
        widthPx = 520,
        heightPx = 260,
        minWidthPx = 460,
        minHeightPx = 240,
        initialX = 320.0,
        initialY = 150.0,
        contentInsetLeft = ContentOffset.LEFT.value.toDouble(),
        contentInsetTop = ContentOffset.TOP.value.toDouble(),
        contentInsetRight = ContentOffset.RIGHT.value.toDouble(),
        contentInsetBottom = ContentOffset.BOTTOM.value.toDouble(),
        onClose = onClose
    ) {
        Div({
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
                gap(18.px)
                property("padding", "44px 26px 26px")
                height(100.percent)
                color(DashboardTheme.TEXT_LIGHT)
            }
        }) {
            Span({
                style {
                    fontSize(22.px)
                    fontWeight("700")
                    textAlign("center")
                    width(100.percent)
                }
            }) { Text(title) }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    gap(14.px)
                    width(100.percent)
                }
            }) {
                Span({
                    style {
                        fontSize(if (snapKey.length > 32) 15.px else 28.px)
                        fontWeight("700")
                        textAlign("center")
                        letterSpacing(0.8.px)
                        property("overflow-wrap", "anywhere")
                    }
                }) { Text(snapKey.ifBlank { "-" }) }

                Button(attrs = {
                    style {
                        padding(0.px)
                        border(0.px, LineStyle.None, Color.transparent)
                        backgroundColor(Color.transparent)
                        cursor(if (snapKey.isBlank()) "default" else "pointer")
                        opacity(if (snapKey.isBlank()) 0.45 else 1)
                    }
                    title("In Zwischenablage kopieren")
                    onClick {
                        if (snapKey.isNotBlank()) {
                            onCopy()
                            copyActive = true
                            scope.launch {
                                delay(140)
                                copyActive = false
                            }
                        }
                    }
                }) {
                    Img(src = if (copyActive) "images/kopieren_active.svg" else "images/kopieren.svg", attrs = {
                        style {
                            width(22.px)
                            height(22.px)
                        }
                    })
                }
            }
        }
    }
}
